export const T = {
  en_GB: {
    appWantsAccess: "wants to access your Quantfolio Platform account",
    unnamedApp: "Unnamed application",
    selfDeclared: "The name is provided by the application and is not verified.",
    redirectsTo: "After approval you are sent to",
    redirectLoopback: "An application running on this computer.",
    redirectKnown: "A known MCP application.",
    redirectFirstParty: "An official Quantfolio app.",
    unknownHostTitle: "Unrecognised destination",
    unknownHostBody:
      "Quantfolio does not recognise this address. Approve only if you started this connection yourself and trust it.",
  },
  nb_NO: {
    appWantsAccess: "vil ha tilgang til Quantfolio Platform-kontoen din",
    unnamedApp: "Applikasjon uten navn",
    selfDeclared: "Navnet er oppgitt av applikasjonen selv og er ikke verifisert.",
    redirectsTo: "Etter godkjenning sendes du til",
    redirectLoopback: "En applikasjon som kjører på denne datamaskinen.",
    redirectKnown: "En kjent MCP-applikasjon.",
    redirectFirstParty: "En offisiell Quantfolio-app.",
    unknownHostTitle: "Ukjent mottaker",
    unknownHostBody:
      "Quantfolio kjenner ikke igjen denne adressen. Godkjenn bare hvis du selv startet tilkoblingen og stoler på den.",
  },
} as const;
